import SiteLayout from '@/components/feature/SiteLayout';
import SectionHeading from '@/components/feature/SectionHeading';
import MediaGrid from '@/components/feature/MediaGrid';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryQuickLinks from '@/pages/home/components/CategoryQuickLinks';
import NewsPreview from '@/pages/home/components/NewsPreview';
import { useSeo } from '@/hooks/useSeo';
import { getAllNews, getFeaturedMedia, getHotMedia, getLatestMedia } from '@/utils/media';

export default function Home() {
  useSeo({
    title: '黄色影视 - 高清电影电视剧免费在线观看平台',
    description:
      '黄色影视致力于为用户提供最新高清电影、电视剧、综艺等影视内容，涵盖多种类型和题材，方便用户在线观看和影视资讯浏览。',
    keywords: '黄色影视,电影,电视剧,影视在线观看,影视推荐,影视资讯,高清影视,在线播放',
  });

  const featured = getFeaturedMedia();
  const hot = getHotMedia(12);
  const latest = getLatestMedia(12);
  const news = getAllNews().slice(0, 5);

  return (
    <SiteLayout withHeaderOffset={false}>
      <HeroCarousel items={featured} />

      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <section className="py-10 md:py-14">
          <SectionHeading title="影视分类" subtitle="按类型快速找到你想看的内容" icon="ri-apps-2-line" />
          <CategoryQuickLinks />
        </section>

        <section className="py-6 md:py-10">
          <SectionHeading
            title="热门推荐"
            subtitle="近期最受关注的影视作品"
            icon="ri-fire-line"
            moreLink="/category/all"
          />
          <MediaGrid items={hot} showType />
        </section>

        <section className="py-6 md:py-10">
          <SectionHeading
            title="最新更新"
            subtitle="刚刚上线与更新中的影视资源"
            icon="ri-time-line"
            moreLink="/category/all"
          />
          <MediaGrid items={latest} showType />
        </section>

        <section className="py-6 pb-2 md:py-10">
          <SectionHeading
            title="影视资讯"
            subtitle="影评、新片推荐与行业动态，把握影视风向"
            icon="ri-newspaper-line"
            moreLink="/news"
          />
          <NewsPreview items={news} />
        </section>
      </div>
    </SiteLayout>
  );
}